import { gql } from "@apollo/client";
import { ImageFragment } from "./image";

export const ResourceBaseFragment = gql`
  fragment ResourceBaseFragment on Resource {
    documentId
    createdAt
    publishedAt
    title
    slug
    resourceStatus
    expireResourceStatusAt
    publicationDate
    subHeader
    type {
      data {
        id
        attributes {
          type
        }
      }
    }
    category {
      data {
        id
        attributes {
          category
        }
      }
    }
    cover {
      data {
        ...ImageFragment
      }
    }
    DefaultContentTemplate {
      __typename
      ... on ComponentCommonAuthorDetailed {
        authors: authors_connection {
          data {
            attributes {
              name
              role
              bio
              avatar {
                data {
                  ...ImageFragment
                }
              }
            }
          }
        }
      }
    }
  }
  ${ImageFragment}
`;

export const ResourceTypeFragment = gql`
  fragment ResourceTypeFragment on ResourceType {
    documentId
    type
  }
`;

export const ResourceCategoryFragment = gql`
  fragment ResourceCategoryFragment on ResourceCategory {
    documentId
    category
    subCategories {
      data {
        id
        attributes {
          category
        }
      }
    }
  }
`;

export const ResourceAssetFragment = gql`
  fragment ResourceAssetFragment on ResourceAsset {
    documentId
    title
    description
    content {
      data {
        attributes {
          url
          name
          ext
          mime
          size
        }
      }
    }
  }
`;
